import { type UserLocation, type UserLocationMetadata, type UserLocationResponse } from '../types/userLocationTypes';

export function parseUserLocation(response?: Partial<UserLocationResponse>): UserLocation | undefined {
  const data = response?.results?.[0];

  if (!data) {
    return;
  }

  return {
    city: data.city || '',
    country: data.country || '',
    latitude: data.latitude ?? 0,
    longitude: data.longitude ?? 0,
    local_station_call_signs: data.local_station_call_signs ?? [],
    metro_code: data.metro_code || '',
    national_stations_call_signs: data.national_stations_call_signs ?? [],
    public_ip: data.public_ip || '',
    region: data.region || '',
    time_zone: data.time_zone || '',
    zip_code: data.zip_code || '',

    metadata: parseLocationMetadata(response.metadata),
  };
}

function parseLocationMetadata(data?: UserLocationResponse['metadata']): UserLocationMetadata | undefined {
  if (!data) {
    return;
  }

  if ('x-platform-location' in data && data['x-platform-location']) {
    return {
      'x-platform-location': data['x-platform-location'],
    };
  }
}
